var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("Preferences")]),_c('b-form-checkbox',{attrs:{"id":"checkbox-show-auto-tag-badge","value":true,"unchecked-value":false},model:{value:(_vm.showAutoTagsBadge),callback:function ($$v) {_vm.showAutoTagsBadge=$$v},expression:"showAutoTagsBadge"}},[_vm._v(" show auto tags badge ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }